<div class="modal-header justify-content-between">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <div>
   <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
  </div>
</div>

@if (isLoading) {
<div class="loading-body">
  <app-loading class="loading-container" [text]="'Loading'"></app-loading>
</div>
} @else {
<div class="modal-body w-100">
  <div class="container">
    <div class="multi-column">
      <div class="column-item" *ngFor="let item of data">
        <span class="header-12">{{ item.title }}</span>
        <p *ngIf="isString(item.content)" class="header-12-1">
          {{ item.content }}
        </p>
        <ol *ngIf="!isString(item.content)">
          <li *ngFor="let point of item.content">
            <span class="header-12-1">{{ point }}</span>
          </li>
        </ol>
      </div>
    </div>

    <div class="tabular-content">
      <app-zorro-table
        tableId="dt-view-modal"
        class="w-100 overflow-auto"
        [columns]="columns"
        [data]="rows"
      ></app-zorro-table>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn btn-accello-primary-light"
      (click)="activeModal.dismiss('Cross click')"
    >
      Close
    </button>
  </div>
</div>

}
